import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';

const initialStateDealer = {
    Dealer: [],
    products: [],
    // currUser: null,
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getDealers = createAsyncThunk(
    'dealer/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllDealer', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            return response.data.Dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);
export const getDealerProduct = createAsyncThunk(
    'getDealerProduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getDealerProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log("hh", response.data)
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

// export const addDelear = createAsyncThunk(
//     'dealer/add',
//     async (data, { dispatch, rejectWithValue }) => {
//         try {
//             // console.log(data);
//             const { dealerImage, MultipleDetails, ...rest } = data;
//             const formData = new FormData();

//             formData.append('dealerImage', dealerImage);
//             formData.append('MultipleDetails', JSON.stringify(MultipleDetails));

//             Object.keys(rest).forEach(key => {
//                 if (Array.isArray(rest[key])) {
//                     rest[key].forEach(item => {
//                         formData.append(key, item);
//                     });
//                 } else {
//                     formData.append(key, rest[key]);
//                 }
//             });

//             if (dealerImage) {
//                 dealerImage.forEach((file, index) => {
//                     if (file instanceof File) {
//                         // New file
//                         formData.append('dealerImage', file);
//                         formData.append(`dealerImageIndex_${formData.getAll('dealerImage').length - 1}`, index);
//                     } else if (typeof file === 'string') {
//                         // Existing file path
//                         formData.append(`ExistingdealerImage_${index}`, file);
//                     }
//                 });
//             }

//             const response = await axiosInstance.post(BASE_URL + '/createDealer', formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                     Authorization: `Bearer ${Cookies.get("accessToken")}`
//                 }
//             });
//             dispatch(setAlert({ text: response.data.message, color: 'success' }));
//             // console.log(response.data);
//             return response.data.Dealer;
//         } catch (error) {
//             return handleErrors(error, dispatch, rejectWithValue);
//         }
//     }
// );

export const addDelear = createAsyncThunk(
    'dealer/add',
    async (data, { dispatch, rejectWithValue }) => {
        try {
            const { dealerImage, MultipleDetails, ...rest } = data;
            const formData = new FormData();

            formData.append('MultipleDetails', JSON.stringify(MultipleDetails));

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (dealerImage) {
                dealerImage.forEach((file, index) => {
                    if (file instanceof File) {
                        formData.append('dealerImage', file);
                        formData.append(`dealerImageIndex_${formData.getAll('dealerImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        formData.append(`ExistingdealerImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.post(BASE_URL + '/createDealer', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data.dealer); // Log the entire response
            dispatch(getDealers());
            return response.data.dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteDealer = createAsyncThunk(
    'dealer/delete',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id);
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteDealer/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getDealers());
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const viewDealer = createAsyncThunk(
    'dealer/view',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id, "id");
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getDealerById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data.Dealer, "response.data.Dealer");
            return response.data.Dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const viewDealerMarketing = createAsyncThunk(
    'dealer/viewDealerMarketing',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id, "id");
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getDealerByIdMarketing/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            console.log(response.data.Dealer, "response.data.Dealer");
            return response.data.Dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

// export const editDealer = createAsyncThunk(
//     'dealer/edit',
//     async (data, { dispatch, rejectWithValue }) => {
//         try {
//             const { _id, ...rest } = data;
//             console.log(data, "data");
//             const response = await axiosInstance.put(`${BASE_URL}/updateDealer/${_id}`, rest, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 }
//             });
//             dispatch(setAlert({ text: response.data.message, color: 'success' }));
//             console.log(response.data);
//             return response.data.Dealer;
//         } catch (error) {
//             return handleErrors(error, dispatch, rejectWithValue);
//         }
//     }
// );

// export const editDealer = createAsyncThunk(
//     'dealer/edit',
//     async (data, { dispatch, rejectWithValue }) => {
//         try {
//             const { _id, UploadPaymentSlip, PaymentDetails, ...rest } = data;

//             const formData = new FormData();
//             formData.append('_id', _id);

//             // Only send new PaymentDetails (without _id)
//             const newPaymentDetails = PaymentDetails.filter(detail => !detail._id);
//             formData.append('PaymentDetails', JSON.stringify(newPaymentDetails));

//             Object.keys(rest).forEach(key => {
//                 if (Array.isArray(rest[key])) {
//                     rest[key].forEach(item => {
//                         formData.append(key, item);
//                     });
//                 } else {
//                     formData.append(key, rest[key]);
//                 }
//             });
//             console.log(UploadPaymentSlip);

//             if (UploadPaymentSlip) {
//                 UploadPaymentSlip.forEach((file, index) => {
//                     if (file instanceof File) {
//                         formData.append(`UploadPaymentSlip`, file);
//                     }
//                 });
//             }
//             console.log(formData.UploadPaymentSlip);


//             const response = await axiosInstance.put(`${BASE_URL}/updateDealer/${_id}`, formData, {
//                 headers: {
//                     'Content-Type': 'multipart/form-data',
//                 }
//             });

//             dispatch(setAlert({ text: response.data.message, color: 'success' }));
//             return response.data.Dealer;
//         } catch (error) {
//             return handleErrors(error, dispatch, rejectWithValue);
//         }
//     }
// );

export const editDealer = createAsyncThunk(
    'dealer/edit',
    async (data, { dispatch, rejectWithValue }) => {
        // console.log(data, "data=====");
        try {
            const { _id, UploadPaymentSlip, PaymentDetails, MultipleDetails, dealerImage, ...rest } = data;

            const formData = new FormData();
            formData.append('_id', _id);

            // Append all PaymentDetails, including existing ones

            formData.append('MultipleDetails', JSON.stringify(MultipleDetails));
            formData.append('PaymentDetails', JSON.stringify(PaymentDetails));

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (dealerImage) {
                dealerImage.forEach((file, index) => {
                    if (file instanceof File) {
                        // New file
                        formData.append('dealerImage', file);
                        formData.append(`dealerImageIndex_${formData.getAll('dealerImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        // Existing file path
                        formData.append(`ExistingdealerImage_${index}`, file);
                    }
                });
            }

            if (UploadPaymentSlip) {
                UploadPaymentSlip.forEach((file, index) => {
                    if (file instanceof File) {
                        // New file
                        formData.append('UploadPaymentSlip', file);
                        formData.append(`UploadPaymentSlipIndex_${formData.getAll('UploadPaymentSlip').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        // Existing file path
                        formData.append(`ExistingUploadPaymentSlip_${index}`, file);
                    }
                });
            }


            const response = await axiosInstance.put(`${BASE_URL}/updateDealer/${_id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // console.log(response.data.Dealer);
            dispatch(getDealers())
            return response.data.Dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const updateDealerStatus = createAsyncThunk(
    'dealer/updateDealerStatus',
    async ({ ids, submitDate }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`${BASE_URL}/updateDealerStatus`, { ids, submitDate }, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getDealers());
            return response.data.Dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const updateBoxStatus = createAsyncThunk(
    'dealer/updateBoxStatus',
    async ({ id, submitDate }, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`${BASE_URL}/updateBoxStatus/${id}`, { submitDate }, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getDealers());
            return response.data.Dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const dealerCommissionStatus = createAsyncThunk(
    'dealer/dealerCommissionStatus',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`${BASE_URL}/dealerCommissionStatus/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            console.log(response.data);
            dispatch(getDealers());
            console.log("response.data.Dealer", response.data.Dealer);
            return response.data.Dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const dealerPaymentStatus = createAsyncThunk(
    'dealer/dealerPaymentStatus',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`${BASE_URL}/dealerPaymentStatus/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getDealers());
            return response.data.Dealer;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

const dealerSlice = createSlice({
    name: 'dealer',
    initialState: initialStateDealer,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getDealers.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Dealers...';
            })
            .addCase(getDealers.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Dealers fetched successfully';
                state.Dealer = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getDealers.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Dealers';
            })
            /////
            .addCase(getDealerProduct.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Dealers...';
            })
            .addCase(getDealerProduct.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Dealers fetched successfully';
                state.products = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getDealerProduct.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Dealers';
            })
            ////
            .addCase(addDelear.pending, (state) => {
                state.loading = true;
                state.message = 'Adding Dealers...';
            })
            .addCase(addDelear.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Dealer.push(action.payload);
                state.message = action.payload?.message || 'Dealer added successfully';
            })
            .addCase(addDelear.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Dealer';
            })
            .addCase(deleteDealer.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Dealer...';
            })
            .addCase(deleteDealer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.users = state.Dealer.filter((user) => user._id !== action.payload);
                state.message = action.payload?.message || 'Dealer deleted successfully';
            })
            .addCase(deleteDealer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Dealer';
            })
            .addCase(editDealer.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Dealer...';
            })
            .addCase(editDealer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.Dealer)) {
                    state.Dealer = state.Dealer.map(dealer =>
                        dealer._id === action.payload?._id ? action.payload : dealer
                    );
                }
                state.message = 'Dealer updated successfully';
            })
            .addCase(editDealer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Dealer';
            })
            .addCase(updateDealerStatus.pending, (state) => {
                state.loading = true;
                state.message = 'Updating Dealer Status...';
            })
            .addCase(updateDealerStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Dealer status updated successfully';
                // dispatch(getDealers());
            })
            .addCase(updateDealerStatus.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Dealer status';
            })
            .addCase(dealerCommissionStatus.pending, (state) => {
                state.loading = true;
                state.message = 'Updating Dealer Commission Status...';
            })
            .addCase(dealerCommissionStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Dealer Commission status updated successfully';
            })
            .addCase(dealerCommissionStatus.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Dealer Commission status';
            })
            .addCase(dealerPaymentStatus.pending, (state) => {
                state.loading = true;
                state.message = 'Updating Dealer Payment Status...';
            })
            .addCase(dealerPaymentStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Dealer Payment status updated successfully';
            })
            .addCase(dealerPaymentStatus.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Dealer Payment status';
            })
            .addCase(updateBoxStatus.pending, (state) => {
                state.loading = true;
                state.message = 'Updating Box Status...';
            })
            .addCase(updateBoxStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Box status updated successfully';
            })
            .addCase(updateBoxStatus.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Box status';
            })
            .addCase(viewDealer.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Dealer...';
            })
            .addCase(viewDealer.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Dealer fetched successfully';
                state.Dealer = action.payload;
            })
            .addCase(viewDealer.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Dealer';
            })
            .addCase(viewDealerMarketing.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Dealer...';
            })
            .addCase(viewDealerMarketing.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Dealer fetched successfully';
                state.Dealer = action.payload;
            })
            .addCase(viewDealerMarketing.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Dealer';
            })

    }
});

export default dealerSlice.reducer;